import { ScmIntegrationsApi, scmIntegrationsApiRef, ScmAuth, scmAuthApiRef } from '@backstage/integration-react';
import { analyticsApiRef, identityApiRef, configApiRef, githubAuthApiRef } from '@backstage/core-plugin-api';
import { MultipleAnalyticsApi } from '@backstage/core-app-api';
import { GoogleAnalytics4 } from '@backstage-community/plugin-analytics-module-ga4';
import { ApiBlueprint } from '@backstage/frontend-plugin-api';

const scmIntegrationsApi = ApiBlueprint.make({
  name: 'scm-integrations',
  params: define =>
    define({
      api: scmIntegrationsApiRef,
      deps: { configApi: configApiRef },
      factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
    }),
});

const scmAuthApi = ApiBlueprint.make({
  name: 'scm-auth',
  params: define =>
    define({
      api: scmAuthApiRef,
      deps: {
        githubAuthApi: githubAuthApiRef,
      },
      factory: ({ githubAuthApi }) => ScmAuth.forGithub(githubAuthApi),
    }),
});

const analyticsApi = ApiBlueprint.make({
  name: 'ga-analytics',
  params: define =>
    define({
      api: analyticsApiRef,
      deps: {
        configApi: configApiRef,
        identityApi: identityApiRef,
      },
      factory: ({ configApi, identityApi }) =>
        MultipleAnalyticsApi.fromApis([
          GoogleAnalytics4.fromConfig(configApi, {
            identityApi,
          }),
        ]),
    }),
});

export const apis = [scmIntegrationsApi, scmAuthApi, analyticsApi];
